import { CurrencyEnum } from '@/enums/CurrencyEnum'

export const DecimalCurrencies: Array<keyof typeof CurrencyEnum> = ['USD', 'AUD', 'CAD', 'GBP', 'SGD', 'EUR']
